import React from 'react';
import * as reactUtils from '../packages/react-utils/react-utils.js';
import '@flixbus/honeycomb-icons-react';
import '../packages/props-utils/prop-types.js';

/**
 * Returns null if child is valid, returns child name if not.
 */
const getInvalidChildName = (child, validChildName) => {
  if (Array.isArray(validChildName)) {
    const a = validChildName.map(validName => reactUtils.isOfType(child, validName));
    if (a.find(result => result === true)) {
      // Child is valid.
      return null;
    }
  } else if (reactUtils.isOfType(child, validChildName)) {
    // Child is valid.
    return null;
  }
  // Child of invalid type, return child name.
  return reactUtils.getElementName(child);
};
/** Returns null if valid, returns error if not. */
const validateChildrenTypes = (children, validChildName, propName, componentName) => {
  let error = null;
  React.Children.forEach(children, child => {
    // If the child is a React.Fragment, run this function again on its children
    if (reactUtils.isFragment(child)) {
      const fragmentChild = child;
      error = validateChildrenTypes(fragmentChild.props.children, validChildName, propName, componentName);
    } else if (/*#__PURE__*/React.isValidElement(child)) {
      const invalidChildName = getInvalidChildName(child, validChildName);
      if (invalidChildName !== null) {
        error = new Error("`".concat(componentName, "` only accepts `").concat(propName, "` of type `").concat(validChildName, "`, but `").concat(invalidChildName, "` is given."));
      }
    } else if (child !== null) {
      // null check allows ternary expression to pass through
      error = new Error("`".concat(componentName, "` only accepts React valid elements as children."));
    }
  });
  return error;
};
const requiredChildrenValidation = validChildName => (props, propName, componentName) => {
  const prop = props[propName];
  if (prop === null || prop === undefined) {
    // Prop wasn't specified. Throw an error.
    return new Error("`".concat(propName, "` is required for `").concat(componentName, "`."));
  }
  // @ts-expect-error prop is not a component but still has children
  return validateChildrenTypes(prop, validChildName, propName, componentName);
};
const optionalChildrenValidation = validChildName => (props, propName, componentName) => {
  const prop = props[propName];
  if (!prop) {
    // Prop wasn't specified, this is valid, do nothing.
    return null;
  }
  // @ts-expect-error prop is not a component but still has children
  return validateChildrenTypes(prop, validChildName, propName, componentName);
};

export { optionalChildrenValidation, requiredChildrenValidation };
